/* eslint-disable camelcase */
/* eslint-disable prefer-rest-params */

import React, { Fragment } from "react";
import DriftWidget from "../components/DriftWidget/DriftWidget";

export const injectDriftChatNonLoggedIn = (Component, props) => (
  <Component {...props} />
);

export const injectDriftChat = (Component, props) => (
  <Fragment>
    <Component {...props} />
    <DriftWidget />
  </Fragment>
);
